import script from "./AssetsDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssetsDetail.vue?vue&type=script&lang=ts&setup=true"

import "./AssetsDetail.vue?vue&type=style&index=0&id=022f19bb&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-022f19bb"]])

export default __exports__